import { motion } from 'framer-motion';
import { FiMinimize2 } from 'react-icons/fi';
import { useState, useEffect } from 'react';

/**
 * Full-screen futuristic focus overlay — massive clock on black void.
 */
export default function FocusOverlay({ displayTime, formatTime, onExit }) {
  const [tick, setTick] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => setTick(t => !t), 500);
    return () => clearInterval(interval);
  }, []);

  const h = Math.floor(displayTime / 3600);
  const m = Math.floor((displayTime % 3600) / 60);
  const s = displayTime % 60;

  return (
    <motion.div
      className="focus-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* Ambient glow */}
      <div className="focus-ambient-glow" />

      <motion.div
        className="focus-content"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, ease: [0.23, 1, 0.32, 1] }}
      >
        <div className="focus-clock">
          <span className="focus-digit">{h.toString().padStart(2, '0')}</span>
          <span className={`focus-colon ${tick ? 'focus-colon--dim' : ''}`}>:</span>
          <span className="focus-digit">{m.toString().padStart(2, '0')}</span>
          <span className={`focus-colon ${tick ? 'focus-colon--dim' : ''}`}>:</span>
          <span className="focus-digit">{s.toString().padStart(2, '0')}</span>
        </div>

        <button className="focus-exit" onClick={onExit}>
          <FiMinimize2 size={18} />
          <span>ESC</span>
        </button>
      </motion.div>
    </motion.div>
  );
}
